import { NewSuggestion } from 'types/suggestions';
import { SPONSORED_INSERT_AFTER_NEW_SUGGESTIONS } from './get-element-index';

type SplitNewSuggestionsResult = {
  leadingNewSuggestions: NewSuggestion[];
  trailingNewSuggestions: NewSuggestion[];
  trailingIndexOffset: number;
};

export const shouldSplitNewSuggestionsAroundSponsored = (
  hasSponsoredProducts: boolean,
  showOnlyCategories: boolean,
) => hasSponsoredProducts && !showOnlyCategories;

export const splitNewSuggestionsForSponsored = (
  newSuggestions: NewSuggestion[],
  sponsoredProductsCount: number,
  shouldSplit: boolean,
): SplitNewSuggestionsResult => {
  if (!shouldSplit) {
    return {
      leadingNewSuggestions: newSuggestions,
      trailingNewSuggestions: [],
      trailingIndexOffset: 0,
    };
  }

  return {
    leadingNewSuggestions: newSuggestions.slice(0, SPONSORED_INSERT_AFTER_NEW_SUGGESTIONS),
    trailingNewSuggestions: newSuggestions.slice(SPONSORED_INSERT_AFTER_NEW_SUGGESTIONS),
    trailingIndexOffset: SPONSORED_INSERT_AFTER_NEW_SUGGESTIONS + sponsoredProductsCount,
  };
};
